<script>
    import Chart from 'chart.js';
    import {generateChart} from 'vue-chartjs';
    import {centerTextPlugin} from '../../utils';

    import { mapGetters } from "vuex";

    Chart.defaults.doughnutWithShadow = Chart.defaults.doughnut
    Chart.controllers.doughnutWithShadow = Chart.controllers.doughnut.extend({
        draw: function (ease) {
            Chart.controllers.doughnut.prototype.draw.call(this, ease)
            let ctx = this.chart.chart.ctx
            ctx.save()
            ctx.shadowColor = 'rgba(0,0,0,0.15)'
            ctx.shadowBlur = 10
            ctx.shadowOffsetX = 0
            ctx.shadowOffsetY = 10
            ctx.responsive = true
            Chart.controllers.doughnut.prototype.draw.apply(this, arguments)
            ctx.restore()
        }
    })

    const DoughnutShadow = generateChart('doughnut-with-shadow', 'doughnutWithShadow')

    export default {
        extends: DoughnutShadow,

        props: ['data'],

        data() {
            return {

            }
        },

        computed: {
            ...mapGetters({
                colors: 'getThemeColors',
            }),

            options() {
                return {
                    legend: {
                        position: 'bottom',
                        labels: {
                            padding: 30,
                            usePointStyle: true,
                            fontSize: 12
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    cutoutPercentage: 80,
                    layout: {
                        padding: {
                            bottom: 20
                        }
                    },
                    tooltips: {
                        backgroundColor: this.colors.foregroundColor,
                        titleFontColor: this.colors.primaryColor,
                        borderColor: this.colors.separatorColor,
                        borderWidth: 0.5,
                        bodyFontColor: this.colors.primaryColor,
                        bodySpacing: 10,
                        xPadding: 15,
                        yPadding: 15,
                        cornerRadius: 0.15
                    }
                };
            }
        },

        mounted() {
            this.addPlugin(centerTextPlugin)
            this.renderChart(this.data, this.options)
        }
    }
</script>
